const JOB_CACHE_WORKSPACE_KEY = 'jobs_cache_workspace_id';

const JOB_CACHE_KEYS = [
  'recentlyDraftedJobs',
  'recentlyArchivedJobs',
  'recentlyRestoredJobs',
  'deletedJobIds',
  'jobsData',
  'jobFormValues',
  'jobFormVlaues',
  'jobFormParsedVlaues',
];

/**
 * Job UI caches pre-date workspace switching. Clear them whenever the active
 * workspace changes so cached drafts or archive markers cannot leak into a
 * different workspace's job list.
 */
export const syncJobWorkspaceCache = (workspaceId = localStorage.getItem('active_workspace_id')) => {
  const normalizedWorkspaceId = workspaceId ? String(workspaceId) : '';
  const cachedWorkspaceId = localStorage.getItem(JOB_CACHE_WORKSPACE_KEY) || '';

  if (cachedWorkspaceId !== normalizedWorkspaceId) {
    JOB_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
    window.recentlyDraftedJobs = [];
    window.recentlyArchivedJobs = [];
  }

  localStorage.setItem(JOB_CACHE_WORKSPACE_KEY, normalizedWorkspaceId);
};
